import React from 'react';
import ThirdPartyAccountManagementCard from '../components/ThirdPartyAccountManagementCard';

export default function ThirdPartyAccountManagementCardScreen() {
  return <ThirdPartyAccountManagementCard />;
}
